import React, { FC } from 'react';
import Svg from '@svg/index';
import theme from '@css/theme';
import classes from '../../../common.module.scss';

interface OwnProps {
  error: string;
  isExpanded: boolean;
  setExpanded: (expand: boolean) => void;
}

const ErrorResponse: FC<OwnProps> = ({ error, setExpanded, isExpanded }: OwnProps) => {
  const changeExpand = () => {
    setExpanded(!isExpanded);
  };
  return (
    <div onClick={changeExpand} data-testid="error">
      <div className={classes.error_preview__container}>
        <div className={classes.error_title}>
          Confronted error while running the query in the warehouse: &nbsp;
        </div>
        <div className="text-ellipsis">{isExpanded ? '' : error}</div>
        <span className={classes.expand_icon}>
          {!isExpanded ? (
            <Svg fill={theme.color.rsPrimary} size={35} name="arrow_chevron_right" />
          ) : (
            <Svg fill={theme.color.rsPrimary} className={classes.down_arrow} name="chevron-down" />
          )}
        </span>
      </div>
      {isExpanded && <div className={classes.error_expanded}>{error}</div>}
    </div>
  );
};
export default ErrorResponse;
